import React from 'react'
import { NavLink } from 'react-router-dom';
const Navbar = () => {
  return (
    <>
       {/* Fixed Navbar */}
       <div className="navbar fixed top-0 w-full z-50 bg-white shadow-md px-4 font-inter">
        {/* START: Logo kiri */}
        <div className="navbar-start">
          <a href="/" className="btn btn-ghost normal-case text-xl">
            <img
              src="/images/logo/logo-dapen.svg"
              alt="Logo"
              className="w-10 h-10"
            />
          </a>
        </div>

        {/* CENTER: Menu di tengah (desktop) */}
        <div className="absolute left-1/2 transform -translate-x-1/2 hidden lg:block">
          <ul className="menu menu-horizontal px-1 text-gray-700">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "font-bold text-black" : "text-gray-700"
                }
              >
                Beranda
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/layanan"
                className={({ isActive }) =>
                  isActive ? "font-bold text-black" : "text-gray-700"
                }
              >
                Layanan
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/tentang-kami"
                className={({ isActive }) =>
                  isActive ? "font-bold text-black" : "text-gray-700"
                }
              >
                Tentang Kami
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/berita"
                className={({ isActive }) =>
                  isActive ? "font-bold text-black" : "text-gray-700"
                }
              >
                Berita
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/laporan"
                className={({ isActive }) =>
                  isActive ? "font-bold text-black" : "text-gray-700"
                }
              >
                Laporan
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/peraturan"
                className={({ isActive }) =>
                  isActive ? "font-bold text-black" : "text-gray-700"
                }
              >
                Peraturan
              </NavLink>
            </li>
          </ul>
        </div>

        {/* END: Dropdown Mobile */}
        <div className="navbar-end lg:hidden">
          <div className="dropdown dropdown-end">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content mt-3 z-[1000] p-2 shadow bg-white rounded-box w-52"
            >
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "font-bold text-black" : "text-gray-700"
                  }
                >
                  Beranda
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/layanan"
                  className={({ isActive }) =>
                    isActive ? "font-bold text-black" : "text-gray-700"
                  }
                >
                  Layanan
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/tentang-kami"
                  className={({ isActive }) =>
                    isActive ? "font-bold text-black" : "text-gray-700"
                  }
                >
                  Tentang Kami
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/berita"
                  className={({ isActive }) =>
                    isActive ? "font-bold text-black" : "text-gray-700"
                  }
                >
                  Berita
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/laporan"
                  className={({ isActive }) =>
                    isActive ? "font-bold text-black" : "text-gray-700"
                  }
                >
                  Laporan
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/peraturan"
                  className={({ isActive }) =>
                    isActive ? "font-bold text-black" : "text-gray-700"
                  }
                >
                  Peraturan
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Spacer untuk konten agar tidak tertutup navbar */}
      <div className="h-16" />
    </>
  )
}

export default Navbar
